import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

const LISTS = [["components", "Composantes"], ["objectives", "Objectifs"], ["profile", "Profil de clientèle"], ["advantages", "Avantages généraux"]];

const ForfaitForm = ({ f, onSaved }) => {
  const [d, setD] = useState({ ...f, ...Object.fromEntries(LISTS.map(([k]) => [k, f[k].join("\n")])) });
  const set = (k) => (e) => setD((p) => ({ ...p, [k]: e.target.value }));
  const save = async () => {
    const body = { name: d.name, tagline: d.tagline, description: d.description,
      ...Object.fromEntries(LISTS.map(([k]) => [k, d[k].split("\n").map((s) => s.trim()).filter(Boolean)])) };
    try { onSaved((await api.put(`/admin/forfaits/${f.slug}`, body)).data); toast.success("Forfait enregistré"); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="space-y-3 rounded-2xl border border-[#EDE3D9] bg-[#FFFDFB] p-5" data-testid={`forfait-form-${f.slug}`}>
      <input className="field-input font-display text-lg" value={d.name} onChange={set("name")} data-testid={`forfait-${f.slug}-name`} />
      <input className="field-input" value={d.tagline} onChange={set("tagline")} placeholder="Phrase d'accroche" data-testid={`forfait-${f.slug}-tagline`} />
      <textarea rows={2} className="field-input" value={d.description} onChange={set("description")} placeholder="Description" data-testid={`forfait-${f.slug}-description`} />
      <div className="grid gap-3 sm:grid-cols-2">
        {LISTS.map(([k, l]) => (
          <div key={k}><p className="mb-1 text-xs text-[#242020]/60">{l} (une par ligne)</p>
            <textarea rows={4} className="field-input text-sm" value={d[k]} onChange={set(k)} data-testid={`forfait-${f.slug}-${k}`} /></div>
        ))}
      </div>
      <button onClick={save} className="btn-primary !py-2.5" data-testid={`forfait-${f.slug}-save`}>Enregistrer</button>
    </div>
  );
};

export default function ForfaitsTab({ forfaits, onSaved }) {
  const replace = (nf) => onSaved(forfaits.map((f) => (f.slug === nf.slug ? nf : f)));
  return (
    <div className="space-y-4" data-testid="forfaits-tab">
      <p className="text-sm text-[#242020]/70">Les textes sur l'assurance, les placements et la fiscalité doivent être validés avant publication. Ne pas indiquer de garanties, rendements ou avantages fiscaux non confirmés.</p>
      <div className="grid gap-6 lg:grid-cols-2">{forfaits.map((f) => <ForfaitForm key={f.slug} f={f} onSaved={replace} />)}</div>
    </div>
  );
}
